module.exports = __webpack_public_path__ + "static/media/open-graph.e3e77609.pdf";